import Http from './index';

export const profile = (params = '') => Http.post(`/profile`, params)
export const updateProfile = (params = '') => Http.put(`/profile/${params.id}`, params)
export const gestation = (params = '') => Http.post(`/profile/${params.id}/gestation`, params.form)
export const updateGestation = (params = '') => Http.put(`/profile/${params.id}/gestation`, params.form)
export const historic = (params = '') => Http.post(`/profile/${params.id}/historic`, params.form)
export const updateHistoric = (params = '') => Http.put(`/profile/${params.id}/historic`, params.form)
export const risk = (params = '') => Http.post(`/profile/${params.id}/risk`, params.form)
export const updateRisk = (params = '') => Http.put(`/profile/${params.id}/risk`, params.form)
export const updateWeight = (params = '') => Http.put(`/profile/${params.id}/weight`, params.form)
export const getMyProfile = () => Http.get(`/profile`)

